import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { TextField, Button, Container, Typography, Box, CssBaseline, Alert, CircularProgress } from '@mui/material';
import axios from 'axios';

const NewPassword = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const resetToken = location.state?.resetToken || '';
  const email = location.state?.email || '';

  const getBasicAuthHeader = () => {
    const username = process.env.REACT_APP_API_USERNAME;
    const password = process.env.REACT_APP_API_PASSWORD;
    const encodedCredentials = btoa(`${username}:${password}`);
    return `Basic ${encodedCredentials}`;
  };

  const handleSubmit = async () => {
    if (newPassword !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }
    setLoading(true);
    try {
      const body = {
        email: email,
        newPassword: newPassword,
        resetToken: resetToken
      };
      //console.log(body)
      const apiUrl2 = process.env.REACT_APP_API_URL;
      const response = await axios.post(`${apiUrl2}/api/user/reset-password`, body, {
        headers: {
        'Authorization': getBasicAuthHeader(),
        },
      });
      //console.log(response)
      if (response.status === 200) {
        navigate('/success');
      } else {
        navigate('/error', { state: { message: response.data.message } });
      }
    } catch (error) {
      console.error('Error resetting password:', error);
      navigate('/error', { state: { message: 'An error occurred while resetting the password.' } });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container component="main" maxWidth="sm" style={{ height: '52vh', display: 'flex', alignItems: 'center' }}>
      <CssBaseline />
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          backgroundColor: 'white',
          padding: 4,
          borderRadius: 2,
          boxShadow: 3,
        }}
      >
        <Typography component="h1" variant="h5">
          Set New Password
        </Typography>
        {error && <Alert severity="error">{error}</Alert>}
        <Box component="form" sx={{ mt: 1 }}>
          <TextField
            margin="normal"
            required
            fullWidth
            label="New Password"
            type="password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
          />
          <TextField
            margin="normal"
            required
            fullWidth
            label="Confirm Password"
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
          <Button
            type="button"
            fullWidth
            variant="contained"
            color="primary"
            sx={{ mt: 3, mb: 2 }}
            onClick={handleSubmit}
            disabled={newPassword !== confirmPassword || !newPassword || !confirmPassword || loading}
          >
            {loading ? <CircularProgress size={24} color="inherit" /> : 'Submit'}
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default NewPassword;
